import {css} from "@emotion/react";

import {calculateRemSize, flex, flexDirection, p, w100} from "@pg-design/helpers-css";

import {IOSMPoisRoutesGrouped} from "../../../maps/actions/fetch_osm_pois_routes_grouped";
import {ExpandablePanel} from "./atoms/ExpandablePanel";
import {MapLayerButtons} from "./MapLayerButtons";

interface IProps {
    transformRoutes: IOSMPoisRoutesGrouped[] | null;
    isOpen: boolean;
    handleClose: () => void;
}

export const ExpandablePanelMapLayers = (props: IProps) => {
    return (
        <ExpandablePanel isOpen={props.isOpen} handleClose={props.handleClose} css={expandableContentMapLayers} textContentCss={modalContentTextStyle}>
            <MapLayerButtons transportRoutes={props.transformRoutes} />
        </ExpandablePanel>
    );
};

const expandableContentMapLayers = css`
    ${w100};
    ${p(4, 3, 2, 3)};
    background-color: #fff;
`;

const modalContentTextStyle = css`
    ${flex()};
    ${flexDirection("column")}
    gap: ${calculateRemSize(1.5)};
    ${w100};
    height: auto;
`;
import {css} from "@emotion/react";

import {calculateRemSize, flex, flexDirection, p, w100} from "@pg-design/helpers-css";

import {IOSMPoisRoutesGrouped} from "../../../maps/actions/fetch_osm_pois_routes_grouped";
import {ExpandablePanel} from "./atoms/ExpandablePanel";
import {MapLayerButtons} from "./MapLayerButtons";

interface IProps {
    transformRoutes: IOSMPoisRoutesGrouped[] | null;
    isOpen: boolean;
    handleClose: () => void;
}

export const ExpandablePanelMapLayers = (props: IProps) => {
    return (
        <ExpandablePanel isOpen={props.isOpen} handleClose={props.handleClose} css={expandableContentMapLayers} textContentCss={modalContentTextStyle}>
            <MapLayerButtons transportRoutes={props.transformRoutes} />
        </ExpandablePanel>
    );
};

const expandableContentMapLayers = css`
    ${w100};
    ${p(4, 3, 2, 3)};
    background-color: #fff;
`;

const modalContentTextStyle = css`
    ${flex()};
    ${flexDirection("column")}
    gap: ${calculateRemSize(1.5)};
    ${w100};
    height: auto;
`;
